import classNames from 'classnames';

const ContentLayout = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return (
        <div
            className={classNames(
                'tw-mx-auto tw-px-[8px] sm:tw-px-0 tw-w-full sm:tw-max-w-[540px] md:tw-max-w-[728px] lg:tw-max-w-[960px] xl:tw-max-w-[1080px]',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default ContentLayout;
